import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientAdapter } from '../http-client-adapter';
import { HttpOptions } from '../interfaces';
import { parseString } from 'xml2js';

import 'rxjs/add/observable/bindCallback';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';

@Injectable()
export class AngularHttpClient extends HttpClientAdapter {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  get(url: string, params: { [name: string]: string }, options: HttpOptions = {}): Observable<any> {
    if (options.headers && options.headers['accept'] && options.headers['accept'].includes('xml')) {
      var observableParseString = <any> Observable.bindCallback(parseString);

      return this.httpClient.get(url, {
        headers: options.headers,
        params: params,
        responseType: 'text'
      })
      .flatMap(res => {
        return observableParseString(res);
      });
    } else {
      return this.httpClient.get(url, {
        headers: options.headers,
        params: params,
      });
    }
  }

  post(url: string, params: { [name: string]: string }, body: any, options: HttpOptions = {}): Observable<any> {
    return this.httpClient.post(url, body, {
      headers: options.headers,
      params: params,
    });
  }

  put(url: string, params: { [name: string]: string }, body: any | null, options: HttpOptions = {}): Observable<any> {
    return this.httpClient.put(url, body, {
      headers: options.headers,
      params: params,
    });
  }

  patch(url: string, params: { [name: string]: string }, body: any | null, options: HttpOptions = {}): Observable<any> {
    return this.httpClient.patch(url, body, {
      headers: options.headers,
      params: params,
    });
  }

  delete(url: string, params: { [name: string]: string }, options: HttpOptions = {}): Observable<any> {
    return this.httpClient.delete(url, {
      headers: options.headers,
      params: params,
    });
  }
}
